<button
  (click)="onClick($event)"
  [ngClass]="[buttonClasses, textClasses]"
  id="{{ item_id }}"
  class="outline-none appearance-none button-area-line"
  type="button"
>
  {{ text }}
</button>
